import QueryParamsUtil from 'api/utils/query-params-util'
import axios from 'axios'

const API_PATH = 'api/v2/admins/exclusive_sellers/products'

const ExclusiveSellerProductsApiV2 = {
  /**
   * Get list of `ES Products`
   * @param {object} params uri parameter
   * @return {object} Collection of `ESProducts`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },

  /**t
   * update selling price for ES produc
   * @param {object} seller_product_id
   * @return {object} selling_price
   */
  updateSellingPrice: async ({ selling_price, seller_product_id }) => {
    const path     = `${API_PATH}/update_selling_price`
    const body     = {
      selling_price     : selling_price,
      seller_product_id : seller_product_id
    }
    const response = axios.patch(path, body)
    return response
  },

  updateSoldOut: async ({ product_id }) => {
    const path     = `${API_PATH}/update_sold_out`
    const body     = {
      product_id: product_id
    }
    const response = axios.patch(path, body)
    return response
  }
}

export default ExclusiveSellerProductsApiV2
